export const DRAWER_TITLE = 'Start an AI process';

export const DRAWER_SUBTITLE = 'Pick a process to run.';

export const SEARCH_PLACEHOLDER = 'Search processes by name…';

export const DRAWER_WIDTH = '560px';

export const EMPTY_STATE_MESSAGE = 'No processes available to start.';

export const NO_MATCH_STATE_MESSAGE = 'No processes match your search.';

export const LOADING_MESSAGE = 'Loading processes…';

export const START_BUTTON_LABEL = 'Start';

export const STARTING_BUTTON_LABEL = 'Starting…';

export const RUNNING_LABEL = 'Currently running';

export const RUNNING_OPEN_LINK_LABEL = 'Open';

export const LAST_RUN_NEVER_TEXT = 'Never run';

// DEV-3049: certification-subject step (SubCompany-scoped processes only).
export const SUBJECT_STEP_BACK_LABEL = 'Back to processes';

export const SUBJECT_STEP_OPTIONAL_SUBTITLE =
  'Select certifications to focus this run on, or leave blank to run across all.';

export const SUBJECT_STEP_REQUIRED_SUBTITLE =
  'Select at least one certification to run this process.';

export const SUBJECT_STEP_LOADING_MESSAGE = 'Loading certifications…';

export const SUBJECT_STEP_EMPTY_MESSAGE = 'No certifications found for this sub company.';
